































































import Analytics from '@/services/Analytics'
import SmsAccount from '@/types/SmsAccount.interface'
import Vue from 'vue'
export default Vue.extend({
    props: {
        large: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        registeredText: `Your phone number is registered with carriers. Giving you access to verified delivery.
                            <br />
                            Maintain registration status by complying with necessary compliance rules.`,
        unregisteredText: `Your phone number is unregistered with carriers putting it at
                            risk of bad delivery.
                            <br />
                            Redeem verified delivery by registering with carriers`
    }),
    mounted() {
        //  Check if we have a number form query param
        const getNumber = this.$route.query.getNumber

        //  If we don't, do nothing
        if (!getNumber) return

        //  Else, open our form with this type pre-selected
        this.popChooseNumber(getNumber)
    },
    computed: {
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        a2pRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            //  If our setting doesn't exist, return false
            if (!a2pEnabled) return false

            //  Else, return based on if we are enabled or not
            return !!a2pEnabled.enabled
        },
        bannerText(): string {
            //  Check if we are registered
            const registered = this.a2pRegistered

            //  If we are not, return our unregistered text
            if (!registered) return this.unregisteredText
            //  Else, return the registered text
            else return this.registeredText
        },
        disabled(): boolean {
            return !this.$store.getters.userHasPermission(3)
        },
        smsAccount(): SmsAccount {
            return this.$store.getters.smsAccount
        },
        widthStyle(): string {
            //  Grab our breakpoint
            const bp = this.$vuetify.breakpoint.name

            //  Depending on our current breakpoint we have a different style for width
            const style =
                {
                    sm: 'width: 600px;',
                    md: 'width: 800px;',
                    lg: 'width: 800px;',
                    xl: 'width: 800px;'
                }[bp] || ''

            //  Return our style
            return style
        }
    },
    methods: {
        disabledPopup(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Access Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onButtonClick(): void {
            //  Check if we are disabled
            const disabled = this.disabled

            //  If we are disabled, do our popup
            if (disabled) return this.disabledPopup()

            //  Else, pop our choose number
            this.popChooseNumber()
        },
        popChooseNumber(type: string): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'choose-number-popup',
                closeable: true,
                closeOnSubmit: true,
                width: '820px',
                props: {
                    defaultType: type
                },
                callback: (type: string) => {
                    //  Report to analytics
                    Analytics.track('GetPhoneNumberCompleted', {
                        phone_number_type: type
                    })
                }
            })
        }
    }
})
